// Minimum width of a suggestion card before the grid reflows to fewer columns.
export const HOME_CARD_MIN_WIDTH_PX = 216;

// Gap between suggestion cards, in px (matches the grid's `gap={4}` → 16px).
export const HOME_CARD_GAP_PX = 16;

// `easeOutCubic` token as a cubic-bezier tuple for motion/react's `ease` prop.
export { EASE_OUT_CUBIC } from "src/utils/easings";

// Faint darkening behind a hovered pill/row.
export const HOME_HOVER_BG = "rgba(0,0,0,0.04)";

// The label over each rail/list section: the nav's group-label spec, inset to line up with its rows' content.
export const LIST_SECTION_LABEL_PROPS = {
  as: "h2",
  size: "sm",
  fontWeight: "medium",
  color: "text.tertiary",
  mx: 2,
} as const;

// One grid for the title row, the content and its skeleton, so they share column edges, centered in the card.
export const HOME_GRID_PROPS = {
  display: "grid",
  gridTemplateColumns: {
    base: "minmax(0, 800px)",
    lg: "minmax(0, 800px) var(--chakra-sizes-80)",
  },
  justifyContent: "center",
  columnGap: { base: 10, xl: 20 },
  width: "100%",
  px: 6,
} as const;

// Resting height token of the elevated chat input (the "surfboard"); `16` scale token (64px).
export const HOME_SURFBOARD_HEIGHT = 16;

// Inner content width shared by every recent-items thumbnail tile so the ads
// and campaigns rows align; each card sets its own height.
export const TILE_INNER_WIDTH = 92;

// Backdrop-blur scrim (not a painted gradient) so it samples the real
// background and stays seamless across the time-of-day tints.
// The scrim's fade, for a scrim painted in a plain fill rather than blurred.
export const HOME_STICKY_SCRIM_MASK_SX = {
  maskImage:
    "linear-gradient(180deg, black 30%, rgba(0,0,0,0.9) 55%, transparent 100%)",
  WebkitMaskImage:
    "linear-gradient(180deg, black 30%, rgba(0,0,0,0.9) 55%, transparent 100%)",
} as const;

export const HOME_STICKY_SCRIM_SX = {
  backdropFilter: "blur(16px)",
  WebkitBackdropFilter: "blur(16px)",
  ...HOME_STICKY_SCRIM_MASK_SX,
} as const;
